import React from 'react';
import { useTour } from '@reactour/tour';
import { createUseStyles } from 'react-jss';

import { t } from 'i18next';

import { useTranslation } from 'react-i18next';

import Susy10 from './assets/img/wanna/susy/susy10.png';
import Button from './components/bootstrap/Button';

/**
 * Steps style
 */
export const styles = {
	/**
	 * Overlay style
	 * @param base
	 */
	maskWrapper: (base) => ({ ...base }),
	maskArea: (base) => ({
		...base,
		rx: 'var(--bs-border-radius)',
	}),
	highlightedArea: (base) => ({ ...base }),
	badge: (base) => ({ ...base }),
	popover: (base) => ({
		...base,
		boxShadow: '0 0 3em rgba(0, 0, 0, 0.5)',
		backgroundColor: 'var(--bs-body-bg)',
		color: 'var(--bs-body-color)',
		borderRadius: 'var(--bs-border-radius)',
	}),
};

/**
 * Image Styles
 * @type {(data?: {theme?: DefaultTheme}) => Classes<"image">}
 */
const useStyles = createUseStyles({
	image: {
		maxHeight: '25vh',
		objectFit: 'contain',
	},
});

/**
 * Prev & Next buttons
 * @returns {JSX.Element}
 * @constructor
 */
const TourNavigation = () => {
	const { currentStep, setCurrentStep } = useTour();
	return (
		<div className="col-12 mt-3">
			<div className="row">
				<div className="col">
					{!!currentStep && (
						<Button icon="ArrowBackIos" color="info" isLink onClick={() => setCurrentStep(currentStep - 1)}>
							Prev
						</Button>
					)}
				</div>
				<div className="col-auto">
					<Button icon="ArrowForwardIos" color="info" isLight onClick={() => setCurrentStep(currentStep + 1)}>
						Next
					</Button>
				</div>
			</div>
		</div>
	);
};

const TempleteListTour = () => {
	const { t } = useTranslation();
	return (
		<div className="row">
			<div className="col-md-12 d-flex align-items-center">
				<div>
					<p className="lead">{t('adminMode.guidline.templateList')}</p>
					<p>{t('adminMode.guidline.generatedTemplateList')}</p>
					<p> {t('adminMode.guidline.clickTemplate')}</p>
					<p>{t('adminMode.guidline.dragTemplate')}</p>
					<p>{t('adminMode.guidline.quickSelectTemplate')}</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

const LastTour = () => {
	const { setIsOpen } = useTour();
	const classes = useStyles();
	return (
		<div className="row">
			<div className="col-md-4">
				<img src={Susy10} className={classes.image} width="100%" alt="" />
			</div>
			<div className="col-md-8 d-flex align-items-center">
				<div>
					<p className="lead">Thank you for following me!</p>
					<p>I know it is very long, but I have actually presented very little of it.</p>
					<p>You can always contact us after purchasing.</p>
				</div>
			</div>
			<div className="col-12 mt-3">
				<div className="row">
					<div className="col-12">
						<p>- What would you like to do now?</p>
					</div>
					<div className="col">
						<Button icon="Close" color="danger" isLink onClick={() => setIsOpen(false)}>
							Close
						</Button>
					</div>
					<div className="col-auto">
						<Button icon="Shopping Cart" color="success" isLight tag="a" href="https://1.envato.market/facit-preview">
							Buy Now
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

const StepTwo = () => {
	const { t } = useTranslation();
	return (
		<>
			<div className="row">
				<div className="col-md-12 d-flex align-items-center">{t('adminMode.guidline.scheduleManagementGuide')}</div>
				<div className="col-md-12 d-flex align-items-center">{t('adminMode.guidline.shortcutKeyGuide')}</div>
				<div className="col-md-12 d-flex align-items-center">
					<ol>
						<li> {t('adminMode.guidline.controlMouseWheelZoom')}</li>
						<li> {t('adminMode.guidline.shiftMouseWheelMoveDates')}</li>
						<li> {t('adminMode.guidline.controlASelectAllPlans')}</li>
						<li> {t('adminMode.guidline.deleteKeyDelete')}</li>
					</ol>
				</div>
				{/* <TourNavigation /> */}
			</div>
		</>
	);
};

/**
 * Tour Steps
 */
const steps = [
	/**
	 * @step 0
	 */
	{
		selector: '.add-templete',
		content: () => (
			<>
				<div className="row">
					<div className="col-md-12 d-flex align-items-center">{t('adminMode.guidline.pleaseCreateTemplate')}</div>
					<TourNavigation />
				</div>
			</>
		),
	},
	/**
	 * @step 1
	 */
	{
		selector: '.templeteBox',
		content: () => <TempleteListTour />,
	},
	/**
	 * @step 2
	 */
	{
		selector: '.react-calendar-container',
		content: () => <StepTwo />,
	},
	// /**
	//  * Dark Mode
	//  * @step 0
	//  */
	// {
	// 	selector: getTargetName('dark-mode'),
	// 	content: () => <DarkModeTour />,
	// },
	// /**
	//  * Lang Selector
	//  * @step 1
	//  */
	// {
	// 	selector: getTargetName('lang-selector'),
	// 	content: () => <LangSwitcherTour />,
	// 	highlightedSelectors: [getTargetName('lang-selector-menu')],
	// 	mutationObservables: [getTargetName('lang-selector-menu')],
	// 	resizeObservables: [getTargetName('lang-selector-menu')],
	// },
	// /**
	//  * Search
	//  * @step 2
	//  */
	// {
	// 	selector: getTargetName('search'),
	// 	content: () => <SearchTour />,
	// 	highlightedSelectors: [getTargetName('search-modal'), getTargetName('card')],
	// 	mutationObservables: [getTargetName('search-modal'), getTargetName('card')],
	// 	resizeObservables: [getTargetName('search-modal'), getTargetName('card')],
	// },
	// /**
	//  * CRM
	//  * @step 3
	//  */
	// {
	// 	selector: `[href="/crm/dashboard"]`,
	// 	content: () => <CrmTour />,
	// },
	// /**
	//  * Date Range
	//  * @step 4
	//  */
	// {
	// 	selector: getTargetName('date-range'),
	// 	content: () => <DateRangeTour />,
	// 	highlightedSelectors: [getTargetName('date-range-menu')],
	// 	mutationObservables: [getTargetName('date-range-menu')],
	// 	resizeObservables: [getTargetName('date-range-menu')],
	// },
	// /**
	//  * List Page
	//  * @step 5
	//  */
	// {
	// 	selector: '#aside-demo-pages__listPages--link',
	// 	content: () => <ListPageTour />,
	// 	highlightedSelectors: ['#aside-demo-pages__listPages'],
	// 	mutationObservables: ['#aside-demo-pages__listPages'],
	// 	resizeObservables: ['#aside-demo-pages__listPages'],
	// },
	// /**
	//  * Filter
	//  * @step 6
	//  */
	// {
	// 	selector: getTargetName('filter'),
	// 	content: () => <FilterTour />,
	// 	highlightedSelectors: [getTargetName('filter-menu')],
	// 	mutationObservables: [getTargetName('filter-menu')],
	// 	resizeObservables: [getTargetName('filter-menu')],
	// },
	// /**
	//  * List
	//  * @step 7
	//  */
	// {
	// 	selector: getTargetName('list'),
	// 	content: () => <ListTour />,
	// 	highlightedSelectors: [getTargetName('list')],
	// 	mutationObservables: [getTargetName('list')],
	// 	resizeObservables: [getTargetName('list')],
	// },
	// /**
	//  * Grid Page
	//  * @step 8
	//  */
	// {
	// 	selector: '#aside-demo-pages__gridPages--link',
	// 	content: () => <GridPageTour />,
	// 	highlightedSelectors: ['#aside-demo-pages__gridPages'],
	// 	mutationObservables: ['#aside-demo-pages__gridPages'],
	// 	resizeObservables: ['#aside-demo-pages__gridPages'],
	// },
	// /**
	//  * Edit Page
	//  * @step 9
	//  */
	// {
	// 	selector: '#aside-demo-pages__editPages--link',
	// 	content: () => <EditPageTour />,
	// 	highlightedSelectors: ['#aside-demo-pages__editPages'],
	// 	mutationObservables: ['#aside-demo-pages__editPages'],
	// 	resizeObservables: ['#aside-demo-pages__editPages'],
	// },
	// /**
	//  * Auth Page
	//  * @step 10
	//  */
	// {
	// 	selector: '[href="/auth-pages/login"]',
	// 	content: () => <AuthPageTour />,
	// 	highlightedSelectors: [
	// 		'[href="/auth-pages/login"]',
	// 		'[href="/auth-pages/sign-up"]',
	// 		'[href="/auth-pages/404"]',
	// 		getTargetName('login-page'),
	// 	],
	// 	mutationObservables: [
	// 		'[href="/auth-pages/login"]',
	// 		'[href="/auth-pages/sign-up"]',
	// 		'[href="/auth-pages/404"]',
	// 		getTargetName('login-page'),
	// 	],
	// 	resizeObservables: [
	// 		'[href="/auth-pages/login"]',
	// 		'[href="/auth-pages/sign-up"]',
	// 		'[href="/auth-pages/404"]',
	// 		getTargetName('login-page'),
	// 	],
	// },
	// /**
	//  * PM
	//  * @step 11
	//  */
	// {
	// 	selector: '#aside-demo-pages__projectManagement--link',
	// 	content: () => <PMTour />,
	// 	highlightedSelectors: ['#aside-demo-pages__projectManagement'],
	// 	mutationObservables: ['#aside-demo-pages__projectManagement'],
	// 	resizeObservables: ['#aside-demo-pages__projectManagement'],
	// },
	// /**
	//  * Projects
	//  * @step 12
	//  */
	// {
	// 	selector: getTargetName('project-item'),
	// 	content: () => <ProjectsTour />,
	// 	highlightedSelectors: [getTargetName('project-item')],
	// 	mutationObservables: [getTargetName('project-item')],
	// 	resizeObservables: [getTargetName('project-item')],
	// },
	// /**
	//  * Project Item
	//  * @step 13
	//  */
	// {
	// 	selector: getTargetName('Mail App'),
	// 	content: () => <ProjectItemTour />,
	// 	highlightedSelectors: [getTargetName('Mail App'), getTargetName('mail-app-modal')],
	// 	mutationObservables: [getTargetName('Mail App'), getTargetName('mail-app-modal')],
	// 	resizeObservables: [getTargetName('Mail App'), getTargetName('mail-app-modal')],
	// },
	// /**
	//  * Knowledge
	//  * @step 14
	//  */
	// {
	// 	selector: '#aside-demo-pages__knowledge--link',
	// 	content: () => <KnowledgeTour />,
	// 	highlightedSelectors: ['#aside-demo-pages__knowledge'],
	// 	mutationObservables: ['#aside-demo-pages__knowledge'],
	// 	resizeObservables: ['#aside-demo-pages__knowledge'],
	// },
	// /**
	//  * Knowledge Item
	//  * @step 15
	//  */
	// {
	// 	selector: getTargetName('Background'),
	// 	content: () => <KnowledgeItemTour />,
	// 	highlightedSelectors: [getTargetName('Background'), getTargetName('knowledge-filter')],
	// 	mutationObservables: [getTargetName('Background')],
	// 	resizeObservables: [getTargetName('Background')],
	// },
	// /**
	//  * Sales
	//  * @step 16
	//  */
	// {
	// 	selector: '#aside-demo-pages__sales--link',
	// 	content: () => <SalesTour />,
	// 	highlightedSelectors: ['#aside-demo-pages__sales'],
	// 	mutationObservables: ['#aside-demo-pages__sales'],
	// 	resizeObservables: ['#aside-demo-pages__sales'],
	// },
	// /**
	//  * Appointment
	//  * @step 17
	//  */
	// {
	// 	selector: '#aside-demo-pages__appointment--link',
	// 	content: () => <AppointmentTour />,
	// 	highlightedSelectors: ['#aside-demo-pages__appointment'],
	// 	mutationObservables: ['#aside-demo-pages__appointment'],
	// 	resizeObservables: ['#aside-demo-pages__appointment'],
	// },
	// /**
	//  * Employee
	//  * @step 18
	//  */
	// {
	// 	selector: getTargetName('Grace'),
	// 	content: () => <EmployeeTour />,
	// 	highlightedSelectors: [getTargetName('Grace')],
	// 	mutationObservables: [getTargetName('Grace')],
	// 	resizeObservables: [getTargetName('Grace')],
	// },
	// /**
	//  * CRM Pages
	//  * @step 19
	//  */
	// {
	// 	selector: '#aside-demo-pages__crm--link',
	// 	content: () => <CRMPagesTour />,
	// 	highlightedSelectors: ['#aside-demo-pages__crm'],
	// 	mutationObservables: ['#aside-demo-pages__crm'],
	// 	resizeObservables: ['#aside-demo-pages__crm'],
	// },
	// /**
	//  * Chat Pages
	//  * @step 20
	//  */
	// {
	// 	selector: '#aside-demo-pages__chat--link',
	// 	content: () => <ChatPagesTour />,
	// 	highlightedSelectors: ['#aside-demo-pages__chat'],
	// 	mutationObservables: ['#aside-demo-pages__chat'],
	// 	resizeObservables: ['#aside-demo-pages__chat'],
	// },
	// /**
	//  * Documentation
	//  * @step 21
	//  */
	// {
	// 	selector: getTargetName('documentation'),
	// 	content: () => <DocTour />,
	// 	highlightedSelectors: ['#aside-menu-two'],
	// 	mutationObservables: ['#aside-menu-two', '#aside-demo-pages', '.aside-body'],
	// 	resizeObservables: ['#aside-menu-two', '#aside-demo-pages', '.aside-body'],
	// },
	/**
	 * Last
	 * @step 22
	 */
	{
		selector: 'body',
		content: () => <LastTour />,
	},
];

export default steps;
